"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
/**
 * Created by vadimdez on 20/01/2017.
 */
__export(require("./src/ngx-order.module"));
__export(require("./src/ngx-order.pipe"));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-order-pipe/dist/index.js
// module id = 598
// module chunks = 3